<div class="tw-absolute tw-bottom-0 tw-text-center tw-p-1 tw-right-0 tw-left-0 tw-text-white">
  {{ app.name }} v{{ app.version }}
</div>
